import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './components/SalesPage';
import { ComboLaunchLanding } from './pages/ComboLaunchLanding';
import { ComboLaunchApp } from './pages/ComboLaunchApp';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Existing Sales Page */}
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />

        {/* New SaaS Application Routes */}
        <Route path="/app" element={<ComboLaunchLanding data-id="element-5" />} data-id="element-4" />
        <Route path="/app/dashboard/*" element={<ComboLaunchApp data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}